import ImageHoverPopup from "../../../../components/ImageHoverPopup";
import titleCaseString from "../../../../utils/titleCaseUtils";

const TabOthers = ({selectedItem}) => {

      const DateFormatter = ({ date }) => {
            const formatDate = (date) => {
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            };
        
            // Format the date without the time
            return new Date(date).toLocaleDateString('en-US', options);
            };
        
            return <div>{formatDate(date)}</div>;
        };

    return (
      <div className="col-12 mb-md-0 mb-4">
        <div className="card shadow-none">


          <div className="card-body">
            <div className="row p-0">

{/* PAYMENT INFO */}
              <div className="col-md-12">
                <table className="table table-bordered"  >
                  <tr className="border">
                    <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">Payment Info</th>
                  </tr>

                  <tbody>
                    <tr style={{ height: 60 }}>
                      <td width={"50%"}><i className="bx bx-purchase-tag-alt" /><span className="fw-medium mx-2">Amount:</span> </td>
                      <td className="fw-bold"> {selectedItem.document_price} </td>
                    </tr>

                    <tr style={{ height: 60 }}>
                      <td>
                        <i className="bx bx-hash" /><span className="fw-medium mx-2">Ref #:</span>
                      </td>
                      <td className="fw-bold">{selectedItem.reference_number?.toUpperCase()}</td>
                    </tr>
                    <tr style={{ height: 60 }}>
                      <td>
                        <i className="bx bx-calendar" /><span className="fw-medium mx-2">Date Paid:</span>

                      </td>
                      {/* <td className="fw-bold">{<DateFormatter date={selectedItem.datePaid?.toString() ?? Date.now()} />}</td> */}

                    </tr>
                    <tr style={{ height: 60 }}>
                      <td>
                        <i className="bx bx-dollar-circle" /><span className="fw-medium mx-2">Payment Method:</span>
                      </td>
                      {/* <td className="fw-bold">{selectedItem.paymentMethod?.toUpperCase()}</td> */}

                    </tr>
                    <tr style={{ height: 60 }}>
                      <td>
                        <i className="bx bx-edit-alt" /><span className="fw-medium mx-2">Description / Remarks:</span>
                      </td>
                      {/* <td className="fw-bold">{selectedItem.description?.toUpperCase()}</td> */}

                    </tr>
                  </tbody>
                </table>
              </div>



{/* LAWYER INFO */}
              <div className="col-md-12">
                {selectedItem.lawyer &&
                  <table className="table table-bordered"  >
                    <tr className="border">
                      <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">Lawyer Info</th>
                    </tr>

                    <tbody>
                      <tr>
                        <td colSpan={2}>
                          <div className="d-flex flex-column align-items-center">
                            {selectedItem.lawyer.user_profile_photo &&
                              <img
                                src={selectedItem.lawyer.user_profile_photo}
                                alt={`1st Party`}
                                style={{ cursor: "pointer", maxHeight: 250, objectFit: "cover" }}
                                className="rounded-pill shadow hover-zoom "
                                height={200} width={200}
                              />
                            }
                          </div>

                        </td>

                      </tr>



                      <tr>
                        <td width={"50%"}>
                          <i className="bx bx-edit" /><span className="fw-medium mx-2">Full Name:</span>
                        </td>
                        <td className="fw-bold">Atty.{' '}
                          {titleCaseString(
                            (selectedItem.lawyer.first_name +
                              (selectedItem.lawyer.middle_name ? ' ' + selectedItem.lawyer.middle_name : '') +
                              ' ' +
                              selectedItem.lawyer.last_name +
                              (selectedItem.lawyer.suffix ? ' ' + selectedItem.lawyer.suffix : '')
                            )
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <i className="bx bx-calendar-alt" /><span className="fw-medium mx-2">Birthday:</span>
                        </td>
                        <td className="fw-bold">{<DateFormatter date={selectedItem.lawyer.birth_date?.toString() ?? Date.now()} />}</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="bx bx-male-female" /><span className="fw-medium mx-2">Gender:</span>
                        </td>
                        <td className="fw-bold">{titleCaseString(selectedItem.lawyer.gender.toUpperCase())}</td>

                      </tr>
                      <tr>
                        <td>
                          <i className="bx bx-phone" /><span className="fw-medium mx-2">Contact:</span>
                        </td>
                        <td className="fw-bold">{selectedItem.lawyer.mobile_number}</td>

                      </tr>
                      <tr>
                        <td>
                          <i className="bx bx-envelope" /><span className="fw-medium mx-2">Email:</span>
                        </td>
                        <td className="fw-bold">{selectedItem.lawyer.email}</td>

                      </tr>

                      <tr>
                        <td>
                          <i className="bx bx-pencil" /><span className="fw-medium mx-2">Signature:</span>
                        </td>

                        <td>
                          {selectedItem.lawyer.signature &&
                            <ImageHoverPopup
                              imageSrc={selectedItem.lawyer.signature}
                              altText="Signature"
                              height={30}
                              label="SIGNATURE"
                            />
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }







              </div>





{/* RECORDINGS INFO */}
              <div className="col-md-12">
                {selectedItem.video_url &&
                  <table className="table table-bordered"  >
                    <tr className="border">
                      <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">VIDEO RECORD</th>
                    </tr>

                    <tbody>
                      <tr>
                        <td colSpan={2}>
                          <div className="d-flex flex-column align-items-center">
                            {selectedItem.video_url &&
                             <video width="640" height="360" controls>
                              <source src={selectedItem.video_url} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                            }
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                }


              </div>
            </div>
          </div>



        </div>
      </div> 
     );
}
 
export default TabOthers;